import { fromJS } from 'immutable'
import { ActionType } from './languages.actions'
import * as languagesTypes from './languages.types'

export const initialState = fromJS({
  languagesList: {
    isLoading: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 20,
    },
    total: 0,
    results: 0,
  },
})

export function languagesReducer(state = initialState, action: ActionType) {
  switch (action.type) {
    case languagesTypes.FETCH_LANGUAGES_LIST_REQUEST: {
      return state.setIn(['languagesList', 'isLoading'], true)
    }

    case languagesTypes.FETCH_LANGUAGES_LIST_SUCCESS: {
      return state
        .setIn(['languagesList', 'isLoading'], false)
        .setIn(['languagesList', 'data'], fromJS(action.payload))
        .setIn(['languagesList', 'total'], fromJS(action.total))
        .setIn(['languagesList', 'results'], fromJS(action.results))
    }

    case languagesTypes.FETCH_LANGUAGES_LIST_FAILURE: {
      return state.setIn(['languagesList', 'isLoading'], false)
    }

    case languagesTypes.UPDATE_FIELD: {
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    }

    default:
      return state
  }
}
